import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Badge, Button, ButtonGroup, Table } from "reactstrap";

import { IoAdd } from "react-icons/io5";
import swal from "sweetalert";
import { LoadingSpinner, isUrdu } from "../../../../constants/const";
import { GetLanguageString, NoResult } from "../../../helper/Components";
import { GetCustomStyles, GetSelectedLanguage } from "../../../helper/Method";
import { ApiFinance } from "../ApiFinance";
import AddFinanceSubCategory from "./AddFinanceAccountCategory";
import EditFinanceAccountCategory from "./EditFinanceAccountCategory";
import UpdateFinanceDimensions from "./UpdateFinanceDimensions";
import UpdateFinanceAccounts from "./UpdateFinanceAccounts";

const FinanceAccountCategories = ({ activeTab }) => {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const [financeAccountCategories, setFinanceAccountCategories] = useState([]);
  const [editModal, setEditModal] = useState(false);
  const [updateAccountModal, setUpdateAccountModal] = useState(false);
  const [updateDimensionModal, setUpdateDimensionModal] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [reload, setReload] = useState(false);
  const [editValues, setEditValues] = useState();
  const [selectedFinanceAccounts, setSelectedFinanceAccounts] = useState([]);
  const [selectedFinanceDimensions, setSelectedFinanceDimensions] = useState(
    []
  );
  const [financeAccountCategoryId, setFinanceAccountCategoryId] = useState([]);

  useEffect(() => {
    if (activeTab === "financeAccountCategories") {
      setLoading(true);
      ApiFinance()
        .GetFinanceSubCategories()
        .then((res) => {
          setFinanceAccountCategories(res.data);
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
    }
  }, [activeTab, reload]);

  const handleOnDelete = (value) => {
    swal({
      title: t("common_delete_message"),
      text: t("common_delete_detail_message"),
      icon: "warning",
      buttons: true,
      className: GetSelectedLanguage() === "en" ? "" : "ur",
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        setLoading(true);
        ApiFinance()
          .DeleteFinanceSubCategory(value)
          .then((res) => {
            // swal({
            //   title: t("finance_finance_category_deleted"),
            //   className: GetSelectedLanguage() === "en" ? "" : "ur",
            //   icon: "success",
            //   buttons: "OK",
            // });
            setReload(!reload);
            setLoading(false);
          })
          .catch((err) => {
            console.log(err);
            swal({
              title: err,
              icon: "error",
              buttons: "OK",
            });
            setLoading(false);
          });
      }
    });
  };

  const handleOnEdit = (e) => {
    setEditValues(e);
    setEditModal(true);
  };

  const handleOnUpdateAccounts = (record) => {
    setFinanceAccountCategoryId(record.id);
    setSelectedFinanceAccounts(record.accounts);
    setUpdateAccountModal(true);
  };

  const handleOnUpdateDimensions = (record) => {
    setFinanceAccountCategoryId(record.id);
    setSelectedFinanceDimensions(record.dimensions);
    setUpdateDimensionModal(true);
  };
  return (
    <div>
      {updateAccountModal ? (
        <UpdateFinanceAccounts
          setUpdateModal={setUpdateAccountModal}
          financeAccountCategoryId={financeAccountCategoryId}
          previouslySelectedFinanceAccounts={selectedFinanceAccounts}
          reload={reload}
          setReload={setReload}
        />
      ) : null}
      {updateDimensionModal ? (
        <UpdateFinanceDimensions
          setUpdateModal={setUpdateDimensionModal}
          financeAccountCategoryId={financeAccountCategoryId}
          previouslySelectedFinanceDimensions={selectedFinanceDimensions}
          reload={reload}
          setReload={setReload}
        />
      ) : null}
      {editModal ? (
        <EditFinanceAccountCategory
          accountCategoryValues={editValues}
          setEditModal={setEditModal}
          setReload={setReload}
          reload={reload}
        />
      ) : null}
      {addModal ? (
        <AddFinanceSubCategory
          setAddModal={setAddModal}
          setReload={setReload}
          reload={reload}
        />
      ) : null}
      <div className="ibox ">
        <div className="ibox-title">
          <h5>
            <GetLanguageString props="finance_tab_finance_account_categories" />
          </h5>
          <Button
            color="white"
            size="sm"
            className={GetCustomStyles().btn_style}
            onClick={() => {
              setAddModal(true);
            }}
          >
            <IoAdd
              size={18}
              color="#18A689"
              style={{ marginRight: 3, marginBottom: 1 }}
            />
            {
              <GetLanguageString props="finance_tab_finance_account_categories_add" />
            }
          </Button>
        </div>
        <div className="ibox-content">
          {!loading ? (
            financeAccountCategories.length !== 0 ? (
              <div className="table-responsive">
                <Table responsive>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>
                        {<GetLanguageString props="finance_tab_category" />}
                      </th>
                      <th>{<GetLanguageString props="finance_tab_finance_sub_category_account_type" />}</th>
                      <th>{<GetLanguageString props="finance_tab_finance_sub_category_dim2_type" />}</th>
                      <th>{<GetLanguageString props="funds_account" />}</th>
                      <th>{<GetLanguageString props="finance_finance_dimensions" />}</th>
                      <th className="text-right">
                        {<GetLanguageString props="common_action" />}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {financeAccountCategories.map((record, index) => {
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td className={isUrdu(record.category) ? "ur" : ""}>
                            {record.category}
                          </td>
                          <td
                            className={
                              isUrdu(record.subCategoryType?.label)
                                ? "ur"
                                : ""
                            }
                          >
                            {record.subCategoryType?.label}
                          </td>
                          <td
                            className={
                              isUrdu(record.dim2CategoryType?.label)
                                ? "ur"
                                : ""
                            }
                          >
                            {record.dim2CategoryType?.label}
                          </td>
                          <td>
                            {record.accounts !== null &&
                            record.accounts?.length > 0
                              ? record.accounts?.map((record1, index1) => {
                                  return (
                                    <Badge
                                      size="xs"
                                      color="info"
                                      className="label label-info m-r-xs"
                                      key={index1}
                                    >
                                      <h5>{record1.label}</h5>
                                    </Badge>
                                  );
                                })
                              : "-"}
                          </td>
                          <td>
                            {record.dimensions !== null &&
                            record.dimensions?.length > 0
                              ? record.dimensions?.map((record1, index1) => {
                                  return (
                                    <Badge
                                      size="xs"
                                      color="primary"
                                      className="label label-primary m-r-xs"
                                      key={index1}
                                    >
                                      <h5>{record1.label}</h5>
                                    </Badge>
                                  );
                                })
                              : "-"}
                          </td>
                          <td className="text-right">
                            <ButtonGroup>
                              {" "}
                              <Button
                                color="white"
                                size="sm"
                                onClick={() => handleOnUpdateAccounts(record)}
                              >
                                {
                                  <GetLanguageString props="finance_tab_finance_accounts_update" />
                                }
                              </Button>{" "}
                              <Button
                                color="white"
                                size="sm"
                                onClick={() => handleOnUpdateDimensions(record)}
                              >
                                {
                                  <GetLanguageString props="finance_tab_finance_dimensions_update" />
                                }
                              </Button>
                              <Button
                                color="white"
                                size="sm"
                                onClick={() => handleOnEdit(record)}
                              >
                                {<GetLanguageString props="common_edit" />}
                              </Button>
                              <Button
                                color="white"
                                size="sm"
                                onClick={() => handleOnDelete(record.id)}
                              >
                                {<GetLanguageString props="common_delete" />}
                              </Button>
                            </ButtonGroup>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            ) : (
              <NoResult />
            )
          ) : (
            LoadingSpinner()
          )}
        </div>
      </div>
    </div>
  );
};

export default FinanceAccountCategories;
